module.exports = "/_next/static/resources/photo-4-5e8f5f09f915019cdf64372dbd389c8c.webp";